import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ProgressBarModule } from '../progress-bar/progress-bar.module';
import { SvgIconModule } from '../svg-icon/svg-icon.module';
import { SearchProgressComponent } from './search-progress.component';
import { NoDataFoundComponent } from './no-data-found.component';

/** Shared search states: the in-process progress panel and the no-results panel. */
@NgModule({
  declarations: [SearchProgressComponent, NoDataFoundComponent],
  imports: [CommonModule, ProgressBarModule, SvgIconModule],
  exports: [SearchProgressComponent, NoDataFoundComponent],
})
export class SearchStateModule {}
